// extracted by mini-css-extract-plugin
var _1 = "changeSubscriptionModalHeader";
export { _1 as "changeSubscriptionModalHeader" }
